import * as React from "react";
import styled from "styled-components";
import { Layout } from "./Layout";
import { colors } from "../colors/color";
import { tablet } from "../BreakPoints";


type FluidLeftFixedRightLayoutProps = {
    headerContainer:React.ReactNode,
    leftContainer:React.ReactNode,
    rightContainer:React.ReactNode,
    noDivider?:boolean
}
export function FluidLeftFixedRightLayout(props:FluidLeftFixedRightLayoutProps):JSX.Element
{
    return (
        <Layout
            noDivider={props.noDivider}
            header={props.headerContainer}
            content={
                <FluidLeftFixedRightLayoutColumns 
                    leftContainer={props.leftContainer}
                    rightContainer={props.rightContainer}
                />
            }
        />
    )
}

type FluidLeftFixedRightLayoutColumnsProps = {
    leftContainer:React.ReactNode,
    rightContainer:React.ReactNode
}

export function FluidLeftFixedRightLayoutColumns(props:FluidLeftFixedRightLayoutColumnsProps):JSX.Element
{
    return (
        <ColumnWrapper>
            <LeftContainer>
                {props.leftContainer}
            </LeftContainer>
            <RightContainer>
                {props.rightContainer}
            </RightContainer>
        </ColumnWrapper>
    )
}

const ColumnWrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
    gap:16px;
    
    @media(min-width: ${tablet}px){
        gap:32px;
        grid-template-columns: auto 400px;
        
    }
`;

const LeftContainer = styled.div`
`;

const RightContainer = styled.div`
    border-left:none;
    padding-left:0px;
    @media(min-width: ${tablet}px){
        border-left:1px solid ${colors.divider};
        padding-left:32px;
    }
`;